export default __webpack_public_path__ + "static/media/spider.48caa8f6.jpeg";